import React, {useState} from "react";
import { Nav, NavLink, NavMenu }
    from "./NavbarElements";
import {IoIosArrowDown, IoIosArrowUp} from 'react-icons/io'
import LOGO from '../assets/WiCLogo.png'

const Navbar = () => {
  const [menuShow, setMenuShow] = useState("")

  const handleClick = () => {
    if (menuShow === "hidden") {
      setMenuShow("")
    } else {
      setMenuShow("hidden")
    }

  }

  return (
    <>
      <Nav>
        <NavMenu>
          <NavLink to="/" activeStyle>
            <img src={LOGO} alt="Women in Computing at UW"></img>
          </NavLink>
          <div id="menu-button" onClick={handleClick}>{menuShow === "hidden" ? <IoIosArrowDown/> : <IoIosArrowUp/>}Links</div>
          <NavLink to="/" className={menuShow} activeStyle>
            Home
          </NavLink>
          <NavLink to="/leadership" className={menuShow} activeStyle>
            Leadership
          </NavLink>
          <NavLink to="/committeebios" className={menuShow} activeStyle>
            Committees
          </NavLink>
          <NavLink to="/involved" clsassName={menuShow} activeStyle>
            Get Involved
          </NavLink>
          <NavLink to="/event" className={menuShow} activeStyle>
            Upcoming Events
          </NavLink>
          <NavLink to="/blog" className={menuShow} activeStyle>
            Blog
          </NavLink>
          <NavLink to="/resources" className={menuShow} activeStyle>
            Resources
            </NavLink>
            <NavLink to="/snapshots" className={menuShow} activeStyle>
            Snapshots
          </NavLink>
        </NavMenu>
      </Nav>
    </>
  );
};

export default Navbar;
